module.exports = __webpack_public_path__ + "static/media/Etiquetas1.bf59ccd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancEtiquetas/Etiquetas1.png
// module id = 2255
// module chunks = 0